import { Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
// import { ThemeService } from './theme.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeLanguageService {
 
    keylanguageMap = {
        "en":"English",
        "hi":"हिन्दी"
     }

  constructor(
      private sessionStorageService: SessionStorageService,
      private translateService: TranslateService) {}

    public changeln(langauageKey: any):void{
        this.sessionStorageService.store('locale', langauageKey);
        this.translateService.use(langauageKey); 
        window.location.reload();
    }

    public getLanguage():string{
        
      let language: string = this.sessionStorageService.retrieve('locale');
      if(language === null || language === undefined){
        language = 'en';
      }
      return language;
   } 
 }
